import { InboxOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';
import { App, Button, Form, Input, InputNumber, Select, Spin } from 'antd';
import Header from 'components/Header/Header';
import { SITE } from 'config/config';
import dayjs from 'dayjs';
import qs from 'query-string';
import React, { useEffect, useState } from 'react';
import {
  createPredictions,
  getAllSetting,
  getFP,
  getIP,
  getMatchList,
  getTime
} from 'service/base';
import { twMerge } from 'tailwind-merge';
import { CONST_SITE } from 'utils/common/const';

const daysOfWeek = {
  Monday: 'Thứ Hai',
  Tuesday: 'Thứ Ba',
  Wednesday: 'Thứ Tư',
  Thursday: 'Thứ Năm',
  Friday: 'Thứ Sáu',
  Saturday: 'Thứ Bảy',
  Sunday: 'Chủ Nhật'
};

const leagues = [
  { id: 1, name: 'ASEAN Championship', logo: '/assets/images/logo/1.webp' },
  { id: 2, name: 'UEFA Champions League', logo: '/assets/images/logo/2.webp' },
  { id: 3, name: 'UEFA Europa League', logo: '/assets/images/logo/3.webp' },
  { id: 4, name: 'English Premier League', logo: '/assets/images/logo/4.png' },
  { id: 5, name: 'Spanish La Liga', logo: '/assets/images/logo/5.png' },
  { id: 6, name: 'Italy Serie A', logo: '/assets/images/logo/6.png' },
  { id: 7, name: 'German Bundesliga', logo: '/assets/images/logo/7.webp' },
  { id: 8, name: 'France Ligue 1', logo: '/assets/images/logo/8.webp' },
  // { id: 9, name: 'England FA Cup', logo: '/assets/images/logo/9.png' },
  // { id: 10, name: 'Spain Supercopa de Espana', logo: '/assets/images/logo/10.webp' },
  { id: 13, name: 'International Friendly', logo: '/assets/images/logo/13.png' }
  // { id: 11, name: 'French Cup', logo: '/assets/images/logo/11.png' }
];

const HomePage = () => {
  const { notification } = App.useApp();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [listDataMatch, setListDataMatch] = useState([]);
  const [timeServer, setTimeServer] = useState(null);
  const [IP, setIP] = useState(null);
  const [FP, setFP] = useState(null);
  const [dataSettings, setDataSettings] = useState([]);

  const [selectedLeagues, setSelectedLeagues] = useState([]);
  const [activeTab, setActiveTab] = useState('all'); // 'all', 'today', 'tomorrow', 'day3', 'day4', 'day5'
  // Hàm tạo danh sách options cho Select
  const getDateOptions = () => {
    const now = dayjs();
    const options = [
      { value: 'all', label: 'Thời gian: Tất cả' },
      { value: 'today', label: `Hôm nay: ${now.format('DD/MM/YYYY')}` },
      { value: 'tomorrow', label: `Ngày mai: ${now.add(1, 'day').format('DD/MM/YYYY')}` },
      {
        value: 'day3',
        label: `${daysOfWeek[now.add(2, 'day').format('dddd')]}: ${now
          .add(2, 'day')
          .format('DD/MM/YYYY')}`
      },
      {
        value: 'day4',
        label: `${daysOfWeek[now.add(3, 'day').format('dddd')]}: ${now
          .add(3, 'day')
          .format('DD/MM/YYYY')}`
      },
      {
        value: 'day5',
        label: `${daysOfWeek[now.add(4, 'day').format('dddd')]}: ${now
          .add(4, 'day')
          .format('DD/MM/YYYY')}`
      }
    ];
    return options;
  };

  // Hàm lọc trận đấu theo tab được chọn
  const getFilteredMatches = () => {
    if (!listDataMatch || listDataMatch.length === 0) return [];

    const now = dayjs();
    const today = now.format('YYYY-MM-DD');
    const tomorrow = now.add(1, 'day').format('YYYY-MM-DD');
    const day3 = now.add(2, 'day').format('YYYY-MM-DD');
    const day4 = now.add(3, 'day').format('YYYY-MM-DD');
    const day5 = now.add(4, 'day').format('YYYY-MM-DD');

    switch (activeTab) {
      case 'today':
        return listDataMatch.filter((match) => {
          const matchDate = dayjs.unix(match.startTime).format('YYYY-MM-DD');
          return matchDate === today;
        });
      case 'tomorrow':
        return listDataMatch.filter((match) => {
          const matchDate = dayjs.unix(match.startTime).format('YYYY-MM-DD');
          return matchDate === tomorrow;
        });
      case 'day3':
        return listDataMatch.filter((match) => {
          const matchDate = dayjs.unix(match.startTime).format('YYYY-MM-DD');
          return matchDate === day3;
        });
      case 'day4':
        return listDataMatch.filter((match) => {
          const matchDate = dayjs.unix(match.startTime).format('YYYY-MM-DD');
          return matchDate === day4;
        });
      case 'day5':
        return listDataMatch.filter((match) => {
          const matchDate = dayjs.unix(match.startTime).format('YYYY-MM-DD');
          return matchDate === day5;
        });
      case 'all':
      default:
        return listDataMatch;
    }
  };

  const handleLeagueClick = (leagueId) => {
    setSelectedLeagues((prevSelectedLeagues) =>
      prevSelectedLeagues.includes(leagueId)
        ? prevSelectedLeagues.filter((id) => id !== leagueId)
        : [...prevSelectedLeagues, leagueId]
    );
  };

  const [scrollPosition, setScrollPosition] = useState(0);
  const leagueListRef = React.createRef();

  const scrollLeft = () => {
    if (leagueListRef.current) {
      leagueListRef.current.scrollBy({ left: -100, behavior: 'smooth' });
      setScrollPosition(leagueListRef.current.scrollLeft - 100);
    }
  };

  const scrollRight = () => {
    if (leagueListRef.current) {
      leagueListRef.current.scrollBy({ left: 100, behavior: 'smooth' });
      setScrollPosition(leagueListRef.current.scrollLeft + 100);
    }
  };

  useEffect(() => {
    fetchAllSetting();
    fetchIP();
    fetchFP();
    fetchTimeServer();

    // Load saved account name from localStorage
    const savedAccount = localStorage.getItem('userAccount');
    if (savedAccount) {
      form.setFieldsValue({ account: savedAccount });
    }
  }, [form]);

  useEffect(() => {
    fetchDataScheduByLS();
  }, []);

  const fetchIP = async () => {
    try {
      const res = await getIP();
      setIP(res);
    } catch (e) {}
  };

  const fetchFP = async () => {
    try {
      const res = await getFP();
      setFP(res);
    } catch (e) {}
  };

  const fetchTimeServer = async () => {
    try {
      const res = await getTime();
      setTimeServer(res);
    } catch (e) {}
  };

  const fetchDataScheduByLS = async () => {
    try {
      setIsLoading(true);
      const res2 = await getMatchList({
        site: CONST_SITE.SC88
      });

      const dataMatch2 =
        res2?.data?.length > 0
          ? res2.data.map((item) => {
              const formatCountDown = dayjs.unix(item.startTime);
              return { ...item, countdown: new Date(formatCountDown) };
            })
          : [];

      setListDataMatch(dataMatch2 || []);
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching match list:', error);
      setIsLoading(false);
    }
  };

  const fetchAllSetting = async (data) => {
    try {
      setIsLoading(true);
      const res = await getAllSetting(qs.stringify({ site: CONST_SITE.SC88 }));
      setDataSettings(res?.data || []);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const TIMEOUT_DURATION = 10000; // 10 seconds

  const createPredictionsWithTimeout = (predictions) => {
    return Promise.race([
      createPredictions(predictions),
      new Promise((_, reject) =>
        setTimeout(() => reject(new Error('Request timed out')), TIMEOUT_DURATION)
      )
    ]);
  };

  const onFinishForm = async (data) => {
    try {
      const filteredMatches = getFilteredMatches();
      if (filteredMatches?.length === 0) return;

      if (!data?.account) {
        notification.warning({
          message: 'Cảnh báo',
          description: 'Vui lòng nhập tên đăng nhập!'
        });
        return;
      }

      // Validate that both home and away scores are provided for each match
      const hasInvalidScores = Object.entries(data).some(([key, value]) => {
        // Bỏ qua field account và các field không phải score
        if (key === 'account' || !key.includes('_')) return false;

        const parts = key.split('_');
        if (parts.length !== 2) return false;

        const [scoreType, matchId] = parts;
        if (!['homeScore', 'awayScore'].includes(scoreType)) return false;

        const otherScoreType = scoreType === 'homeScore' ? 'awayScore' : 'homeScore';
        const otherScoreKey = `${otherScoreType}_${matchId}`;
        const otherValue = data[otherScoreKey];

        // Kiểm tra nếu một trong hai score có giá trị nhưng score kia không có
        const hasValue = value !== undefined && value !== null && value !== '';
        const hasOtherValue = otherValue !== undefined && otherValue !== null && otherValue !== '';

        if (hasValue && !hasOtherValue) {
          return true;
        }

        return false;
      });

      if (hasInvalidScores) {
        notification.warning({
          message: 'Cảnh báo',
          description: 'Vui lòng nhập đầy đủ cả hai bên tỉ số cho mỗi trận đấu!'
        });
        return;
      }

      setIsLoadingSubmit(true);

      const resultGroup = groupScoresByMatchId(data, IP, FP, filteredMatches);

      if (resultGroup.length === 0) {
        notification.warning({
          message: 'Cảnh báo',
          description: 'Vui lòng dự đoán ít nhất một trận đấu!'
        });
        setIsLoadingSubmit(false);
        return;
      }

      const res = await createPredictionsWithTimeout(resultGroup);
      if (res?.code === 0) {
        // Save account name to localStorage on successful submission
        localStorage.setItem('userAccount', data.account);

        notification.success({
          message: 'Thành công',
          description: 'Dự đoán tỉ số thành công!'
        });
        form.resetFields(Object.keys(form.getFieldsValue()).filter((key) => key !== 'account'));
      } else {
        if (res.valid === false) {
          notification.error({
            message: res.title_mess,
            description: res?.text_mess
          });
        } else {
          notification.error({
            message: 'Lỗi',
            description: res?.message
          });
        }
      }
      setIsLoadingSubmit(false);
    } catch (error) {
      notification.error({
        message: 'Lỗi',
        description: error.message || 'Đã xảy ra lỗi khi gửi dự đoán!'
      });
      setIsLoadingSubmit(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    if (!errorInfo?.values?.account) {
      notification.warning({
        message: 'Cảnh báo',
        description: 'Vui lòng nhập tên đang nhập!'
      });
    } else {
      notification.warning({
        message: 'Cảnh báo',
        description: 'Vui lòng điền đầy đủ thông tin!'
      });
    }
  };

  const onFinishCountDown = () => {
    console.log('Countdown finished');
  };

  const groupScoresByMatchId = (input, ip, fp, matchInfo) => {
    const groupedMatches = Object.entries(input).reduce((acc, [key, value]) => {
      if (key === 'account') return acc;

      const parts = key.split('_');
      if (parts.length !== 2) return acc;

      const [scoreType, matchId] = parts;
      if (!matchId || !['homeScore', 'awayScore', 'sameScore'].includes(scoreType)) return acc;

      // Kiểm tra giá trị hợp lệ
      if (value === undefined || value === null || value === '') return acc;

      if (!acc[matchId]) {
        acc[matchId] = {
          matchId,
          account: input.account,
          homeScore: undefined,
          awayScore: undefined,
          sameScore: undefined
        };
      }

      if (scoreType === 'homeScore') {
        acc[matchId].homeScore = value;
      } else if (scoreType === 'awayScore') {
        acc[matchId].awayScore = value;
      } else if (scoreType === 'sameScore') {
        acc[matchId].sameScore = value;
      }

      return acc;
    }, {});

    return Object.values(groupedMatches)
      .filter(
        (match) =>
          match.homeScore !== undefined &&
          match.awayScore !== undefined &&
          match.sameScore !== undefined &&
          match.homeScore !== null &&
          match.awayScore !== null &&
          match.sameScore !== null &&
          match.homeScore !== '' &&
          match.sameScore !== '' &&
          match.awayScore !== ''
      )
      .map(({ matchId, account, homeScore, awayScore, sameScore }) => {
        const matchDetails = matchInfo.find(
          (match) => parseInt(match.matchId) === parseInt(matchId)
        );

        return {
          matchId,
          homeScore,
          awayScore,
          sameScore,
          account,
          ip,
          fp,
          homeName: matchDetails ? matchDetails.homeName : 'Unknown',
          awayName: matchDetails ? matchDetails.awayName : 'Unknown',
          site: SITE
        };
      });
  };

  const showListItemMatch = (matchList) => {
    if (!matchList || matchList.length <= 0) {
      return (
        <div className="flex flex-col items-center justify-center py-8">
          <InboxOutlined className="text-6xl text-gray-300 mb-4" />
          <p className="text-center text-gray-500">Không có trận đấu nào để dự đoán</p>
        </div>
      );
    } else {
      const filteredMatchList =
        selectedLeagues.length > 0
          ? matchList.filter((item) =>
              selectedLeagues.includes(
                leagues.find((league) => league.name === item.leagueName)?.id
              )
            )
          : matchList;

      const filteredByTime = filteredMatchList.filter((item) => timeServer <= item.countdown);

      const itemMatch = filteredByTime.map((item, index) => {
        // const matchDayOfWeek = daysOfWeek[dayjs(item.startTime * 1000).format('dddd')]; // Calculate day of week for each match
        return (
          <div
            key={index}
            className="bg-[#edeff1] border border-[#dcdfe3] rounded-[20px] flex flex-col gap-3 relative"
          >
            {/* Time/Date Badge - Top Left */}
            <div className="bg-[#f27121] w-[35%] rounded-tl-[20px] rounded-br-[20px] px-4 py-1">
              <p className="font-bold text-base leading-6 text-white text-center mb-0 whitespace-nowrap">
                {dayjs(item.startTime * 1000).format('HH:mm DD/MM')}
              </p>
            </div>

            {/* Teams and Score Inputs */}
            <div className="flex gap-3 items-center px-5">
              {/* Teams Column */}
              <div className="flex-1 flex flex-col gap-3">
                {/* Home Team */}
                <div className="flex gap-3 items-center">
                  <div className="w-8 h-8 shrink-0 flex items-center justify-center">
                    <img
                      alt={item.homeName}
                      className="w-full h-full object-contain"
                      src={item.homeLogo}
                    />
                  </div>
                  <p className="font-bold text-base leading-6 text-[#f27121] mb-0 whitespace-nowrap">
                    {item.homeName}
                  </p>
                </div>

                {/* Away Team */}
                <div className="flex gap-3 items-center">
                  <div className="w-8 h-8 shrink-0 flex items-center justify-center">
                    <img
                      alt={item.awayName}
                      className="w-full h-full object-contain"
                      src={item.awayLogo}
                    />
                  </div>
                  <p className="font-bold text-base leading-6 text-[#f27121] mb-0 whitespace-nowrap">
                    {item.awayName}
                  </p>
                </div>
              </div>

              {/* Score Inputs Column */}
              <div className="flex flex-col gap-3">
                {/* Home Score */}
                <Form.Item className="mb-0" name={`homeScore_${item.matchId}`}>
                  <InputNumber
                    disabled={timeServer > item.countdown}
                    controls={false}
                    min={0}
                    max={99}
                    maxLength={2}
                    placeholder="-"
                    className="bg-[#dcdfe3] border-0 w-full text-center font-bold text-sm text-[#3e4c5c] rounded-[8px]"
                    style={{
                      textAlign: 'center',
                      width: '60px',
                      height: '36px',
                      padding: '8px 16px'
                    }}
                  />
                </Form.Item>

                {/* Away Score */}
                <Form.Item className="mb-0" name={`awayScore_${item.matchId}`}>
                  <InputNumber
                    disabled={timeServer > item.countdown}
                    controls={false}
                    min={0}
                    max={99}
                    maxLength={2}
                    placeholder="-"
                    className="bg-[#dcdfe3] border-0 w-full text-center font-bold text-sm text-[#3e4c5c] rounded-[8px]"
                    style={{
                      textAlign: 'center',
                      width: '60px',
                      height: '36px',
                      padding: '8px 16px'
                    }}
                  />
                </Form.Item>
              </div>
            </div>

            {/* Similar Predictions Info and Confirm Button */}
            <div className="flex gap-3 items-center px-5">
              <div className="flex-1 bg-white border border-[#b8bfc7] rounded-[8px] px-2 h-[40px] flex items-center">
                <Form.Item className="mb-0 w-full" name={`sameScore_${item.matchId}`}>
                  <InputNumber
                    disabled={timeServer > item.countdown}
                    controls={false}
                    min={0}
                    maxLength={5}
                    placeholder="Số người dự đoán giống bạn"
                    className="w-full !border-0 !shadow-none !h-[40px] text-center font-normal text-base text-[#3e4c5c] [&_.ant-input-number-input]:!h-full [&_.ant-input-number-input]:!leading-[44px] [&_.ant-input-number-input]:!p-0"
                  />
                </Form.Item>
              </div>
              <Button
                type="primary"
                htmlType="submit"
                loading={isLoadingSubmit}
                className="bg-[#f27121] border border-[#fac6a6] h-[40px] text-white font-bold text-sm rounded-[8px] px-4 py-2.5 whitespace-nowrap"
                style={{
                  background: 'linear-gradient(to right, #f27121, #f27121)',
                  border: '1px solid #fac6a6'
                }}
              >
                XÁC NHẬN
              </Button>
            </div>

            {/* League Name - Bottom */}
            <div className="bg-[#f27121] rounded-bl-[20px] rounded-br-[20px] px-4 py-1">
              <p className="font-bold text-base leading-6 text-white text-center mb-0 whitespace-nowrap">
                {item.leagueName}
              </p>
            </div>
          </div>
        );
      });
      if (!itemMatch || itemMatch.length <= 0) {
        return (
          <div className="flex flex-col items-center justify-center py-8">
            <InboxOutlined className="text-6xl text-gray-300 mb-4" />
            <p className="text-center text-gray-500">Không có trận đấu nào để dự đoán</p>
          </div>
        );
      } else {
        return (
          <div className="w-full h-full grid grid-cols-1 md:grid-cols-2 gap-6 mt-2 md:px-3 items-center justify-center">
            {itemMatch}
          </div>
        );
      }
    }
  };

  return (
    <div className={twMerge(SITE, 'w-full h-full')}>
      <img
        src="bg.png"
        alt="Background"
        className="w-full h-full fixed right-0 bottom-0 object-cover object-center"
      />
      <img
        src="/assets/images/flag_1.png"
        alt="Flag left"
        className="fixed top-0 left-0 z-0 w-[120px] md:w-[180px] lg:w-[220px] h-auto pointer-events-none"
      />
      <img
        src="/assets/images/flag_2.png"
        alt="Flag right"
        className="fixed top-0 right-0 z-0 w-[120px] md:w-[180px] lg:w-[220px] h-auto pointer-events-none"
      />
      <div className="container relative z-10 pb-[24px] md:pb-[32px] px-2">
        <Header />

        <div
          className="mx-auto mt-2 max-w-[1000px] bg-white/95 border-2 border-solid shadow shadow-primary p-2 w-full md:pb-8 md:pt-4 rounded-3xl"
          style={{
            background: '#FFFFFF80',
            borderColor: '#f27121',
            borderRadius: '1.5rem'
          }}
        >
          <div className="flex space-x-6 mt-4 justify-center items-center">
            <Button
              type="link"
              icon={<LeftOutlined />}
              onClick={scrollLeft}
              className="text-black  !px-0 !mx-0"
            />
            <div
              className="flex overflow-x-auto scrollbar-custom pb-2 !mx-0"
              ref={leagueListRef}
              style={{ scrollBehavior: 'smooth' }}
            >
              {leagues.map((league) => (
                <div
                  key={league.id}
                  className={twMerge(
                    'flex justify-center items-center p-1 mx-2 rounded-lg cursor-pointer transition-all duration-300 hover:scale-105',
                    selectedLeagues.includes(league.id)
                      ? 'bg-gradient-to-br from-[#f27121] to-[#63c8f2] shadow-lg shadow-[#63c8f2] border-2 border-[#f27121]'
                      : 'bg-white/80 backdrop-blur-sm border-2 border-[#f27121]/30 hover:border-[#f27121] hover:shadow-md'
                  )}
                  style={{ width: '80px', minWidth: '80px', border: '1px solid #f27121' }}
                  onClick={() => handleLeagueClick(league.id)}
                >
                  <img src={league.logo} alt={league.name} className="h-12 object-contain" />
                </div>
              ))}
            </div>
            <Button
              type="link"
              icon={<RightOutlined />}
              onClick={scrollRight}
              className="text-black !px-0 !mx-0"
            />
          </div>

          <div className="relative w-full h-full">
            <Form
              name="formMatch"
              onFinish={onFinishForm}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
              form={form}
              initialValues={{ account: '' }}
            >
              <div className="w-full h-full">
                {isLoading ? (
                  <div className="w-full h-full text-center py-8">
                    <Spin />
                  </div>
                ) : (
                  <div className="flex flex-col w-full h-full items-center mt-2">
                    <div className="flex w-full h-full items-center justify-between flex-row gap-2 md:mx-3 md:flex-row">
                      <div className="w-full md:w-auto md:px-0 md:ml-3">
                        <div className="flex items-center justify-start w-full min-w-[150px] max-w-[168px] md:max-w-[220px]">
                          <Select
                            value={activeTab}
                            onChange={(value) => setActiveTab(value)}
                            options={getDateOptions()}
                            className="custom-select w-full h-[36px] rounded-full"
                            popupClassName="w-[300px] custom-select-dropdown"
                          />
                        </div>
                      </div>
                      <div className="flex py-1 md:py-2">
                        <Form.Item name="account" className="mb-0">
                          <Input
                            placeholder="Nhập tên đăng nhập ..."
                            maxLength={20}
                            className="h-[36px] w-[96px] md:w-[200px] rounded-l-[30px] rounded-r-none border-[#c9c9c9] text-[12px] px-[17px] py-[10px]"
                            style={{
                              borderRight: 'none'
                            }}
                            rules={[
                              {
                                required: true,
                                message: 'Vui lòng điền tên đăng nhập!'
                              }
                            ]}
                          />
                        </Form.Item>
                        <Form.Item className="mb-0 items-center justify-center md:mr-3">
                          <Button
                            type="primary"
                            htmlType="submit"
                            loading={isLoadingSubmit}
                            className="text-white font-semibold rounded-l-none rounded-r-[30px] border-0 h-[36px] w-[80px] md:w-[124px] text-[12px] md:text-[14px]"
                            style={{
                              background: '#f27121'
                            }}
                          >
                            Xác nhận
                          </Button>
                        </Form.Item>
                      </div>
                    </div>
                    <div className="w-full h-full">{showListItemMatch(getFilteredMatches())}</div>
                  </div>
                )}
                <div className="flex items-center justify-between mt-2"></div>
              </div>
            </Form>
          </div>
        </div>
        {/* Lịch Thi Đấu */}
        {/* <div
          className="hidden mx-auto max-w-[1320px] bg-white/95 border-2 border-solid shadow shadow-primary mt-4 p-2 w-full md:pb-4 md:pt-4 rounded-3xl"
          style={{
            background: '#FFFFFF80',
            borderColor: '#f27121',
            borderRadius: '1.5rem'
          }}
        >
          <div className="flex items-center justify-center p-3">
            <img
              src="/assets/images/match/plan.png"
              alt="Lịch thi đấu hot"
              className="h-auto max-h-[60px] object-contain"
            />
          </div>

          <div className="p-3 border-none border-0">
            <iframe
              src="https://football-widget.pages.dev/"
              //   width="100%"
              height="600"
              //   frameBorder="0"
              //   allowFullScreen
              title="Football Widget"
              className="w-full border-0 border-none rounded-lg"
            />
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default HomePage;
